import React from 'react';
import { ArrowRight } from 'lucide-react';
import AppCard from './AppCard';

// A shared Power BI report view: opens the report with the sender's filters.
const PowerBIFilterShareMessage = ({ message }) => {
  const filterData = (message.attachments || []).find((att) => att.type === 'pbi_filter_share');
  if (!filterData) return null;

  if (!filterData.stateId || !filterData.reportId) {
    console.error('Missing required filter data fields:', filterData);
    return null;
  }

  const counts = filterData.filterCounts || {
    report: filterData.filterState?.reportFilters?.length || 0,
    page: filterData.filterState?.pageFilters?.length || 0,
    visual: filterData.filterState?.visualFilters?.length || 0,
  };
  const total = counts.total || (counts.report || 0) + (counts.page || 0) + (counts.visual || 0);
  const summary = total > 0
    ? `${total} filter${total !== 1 ? 's' : ''}${counts.visual > 0 ? ` · ${counts.visual} slicer${counts.visual !== 1 ? 's' : ''}` : ''}`
    : 'Report view';

  const handleApplyFilters = () => {
    window.location.href = `/report/${filterData.reportId}?filterState=${filterData.stateId}`;
  };

  return (
    <AppCard
      title={filterData.reportName || 'Shared report view'}
      subtitle={summary}
      footNote="Opens with the shared filters"
      action={<>View with filters <ArrowRight size={14} aria-hidden="true" /></>}
      onOpen={handleApplyFilters}
    />
  );
};

export default PowerBIFilterShareMessage;
